<template>
    <div class="user--image" v-bind:class="{ show: isActive }">
        <a :href="getUserId()">
            <img  src="/template/images/users/0.jpg" alt="user">
        </a>
        <!--<a @click="isActive = !isActive;" href="" :aria-expanded="isActive == true">
            <img  src="/template/images/users/0.jpg" alt="user">
        </a>
        <div class="dropdown-menu dropdown-menu-right scale-up" v-bind:class="{ show: isActive }">
            <div class="dropdown-user">
                <div class="dw-user-box">
                    <div class="u-img">
                        <img src="/template/images/users/0.jpg" alt="user">
                    </div>
                    <div class="u-text">
                        <h4>{{this.details.name}} {{this.details.surname}}</h4>
                        <p class="text-muted">{{this.details.email}}</p>
                    </div>
                </div>
                <a :href="getUserId()"><i class="ti-settings"></i>Account Settings</a>
                <a href="#" @click="logout()"><i class="fa fa-power-off"></i>Logout</a>
            </div>
        </div>-->
    </div>
</template>


<script>
    export default {
        mounted() {
            // console.log(this.details);
        },
        data()  {
            return {
                isActive: false
            }
        },
        methods: {
            logout() {
                axios.post('/logout', {
                }).then(function (response) {
                    location.href="/";
                });
            },
            getUserId() {
                return "/profile";
            }

        },
        created: function () {
        },
        props: {
            details: {
                type: Object,
                required: true
            }
        }


    }
</script>
